<template>
  <div>
    <el-input
      v-model="content"
      @focus="initDir"
    />

    <el-dialog
      :visible.sync="dialogVisible"
      title="关键词选择"
      width="1260px"
      top="5vh"
      class="keyword-dialog"
    >
      <!-- 固定在顶部的搜索和已选区域 -->
      <div class="fixed-header">
        <!-- 已选关键词展示区 -->
        <div v-if="selectedKeywords.length > 0" class="selected-container">
          <div class="selected-label">已选中：</div>
          <div class="selected-items">
            <el-tag
              v-for="(kw, idx) in selectedKeywords"
              :key="'selected-'+idx"
              closable
              @close="removeSelected(kw[filedMap.dCode])"
            >
              {{ kw[filedMap.dName] }}
            </el-tag>
          </div>
        </div>
        <!-- 搜索框 -->
        <div class="search-container">
          <el-input
            v-model="pinyinCode"
            placeholder="输入拼音首字母搜索"
            size="medium"
            @change="findKeyword"
          />
        </div>

      </div>

      <!-- 关键词列表区域 -->
      <div v-loading="loading" class="dic-wrap">
        <div class="container">
          <div
            v-for="(item,index) in dirList"
            :key="'line-' + index"
            class="dic-item flex flex-row"
          >
            <div :style="labelStyle" class="dic-title-con flex align-center mr-10">
              <span class="dic-title">
                {{ item[0] }}
              </span>
            </div>
            <div class="keyword-con flex flex-row align-start items-wrap">
              <span
                v-for="keyword in item[1]"
                :key="keyword.id"
                :style="keywordStyle"
                class="keyword cursor-pointer"
                :class="{selected: isSelected(keyword[filedMap.dCode])}"
                @click="toggleSelect(keyword)"
              >
                {{ keyword[filedMap.dName] }}
                <i v-if="isSelected(keyword[filedMap.dCode])" class="el-icon-check selected-icon" />
              </span>
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmSelection">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { findAll, postData } from "@/api/ik/data/dataApi"
import _ from "lodash"

export default {
  name: "KeyWord",
  props: {
    code: {
      type: String,
      default: "sym"
    },
    keywordWidth: {
      type: Number,
      default: 116
    },
    labelWidth: {
      type: Number,
      default: 82
    },
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      dialogVisible: false,
      dirList: [],
      loading: false,
      content: "",
      url: "",
      filedMap: {
        id: `symDirectoryId`,
        code: `symDirectoryCode`,
        name: `symDirectoryName`,
        dId: `symDictionaryId`,
        dCode: `symDictionaryCode`,
        dName: `symDictionaryName`
      },
      pinyinCode: "",
      // 存储选中的关键词对象
      selectedKeywords: [],
      // 原始选中的文本（用于取消时恢复）
      originalContent: ""
    }
  },
  computed: {
    storeCode() {
      return this.$store.getters['user/getStoreCode']
    },
    keywordStyle() {
      return {
        width: `${this.keywordWidth}px`,
        fontSize: '14px'
      }
    },
    labelStyle() {
      return {
        minWidth: `${this.labelWidth}px`
      }
    }
  },
  watch: {
    value(val) {
      this.content = val
    }
  },
  created() {
    this.url = `clinic/clinicdic/clinicdiagdic/clinic${this.code}dic`.toLocaleLowerCase()
    this.filedMap = {
      id: `${this.code}DirectoryId`,
      code: `${this.code}DirectoryCode`,
      name: `${this.code}DirectoryName`,
      dId: `${this.code}DictionaryId`,
      dCode: `${this.code}DictionaryCode`,
      dName: `${this.code}DictionaryName`
    }
  },
  methods: {
    // 初始化关键词列表
    initDir() {
      this.dialogVisible = true
      this.originalContent = this.content

      // 初始化已选关键词
      this.selectedKeywords = []
      if (this.content) {
        const names = this.content.split(' ').filter(Boolean)
        if (this.dirList.length === 0) {
          // 如果数据未加载，先加载数据
          this.findKeyword().then(() => {
            this.initSelectedKeywords(names)
          })
          return
        }
        this.initSelectedKeywords(names)
      } else if (this.dirList.length === 0) {
        this.findKeyword()
      }
    },

    // 根据名称初始化已选关键词
    initSelectedKeywords(names) {
      this.dirList.forEach(group => {
        group[1].forEach(kw => {
          if (names.includes(kw[this.filedMap.dName])) {
            this.selectedKeywords.push(kw)
          }
        })
      })
    },

    // 切换关键词选中状态
    toggleSelect(keyword) {
      const code = keyword[this.filedMap.dCode]
      const index = this.selectedKeywords.findIndex(kw =>
        kw[this.filedMap.dCode] === code
      )

      if (index > -1) {
        this.selectedKeywords.splice(index, 1)
      } else {
        this.selectedKeywords.push(keyword)
      }
    },

    // 检查是否已选中
    isSelected(code) {
      return this.selectedKeywords.some(kw =>
        kw[this.filedMap.dCode] === code
      )
    },

    // 移除已选关键词
    removeSelected(code) {
      this.selectedKeywords = this.selectedKeywords.filter(kw =>
        kw[this.filedMap.dCode] !== code
      )
    },

    // 确定选择
    confirmSelection() {
      // 生成关键词字符串
      this.content = this.selectedKeywords
        .map(kw => kw[this.filedMap.dName])
        .join(' ')

      // 发送权重增加请求
      this.selectedKeywords.forEach(keyword => {
        const pd = {
          storeCode: this.storeCode,
          dictionaryCode: keyword[this.filedMap.dCode]
        }
        postData(this.url + "/do/increaseweight", pd)
      })

      this.$emit("input", this.content)
      this.dialogVisible = false
    },

    /**
     * 查询关键词
     */
    findKeyword() {
      this.loading = true
      const pd = {
        storeCode: this.storeCode,
        sffectiveSign: "1",
        pinyinCode: this.pinyinCode
      }
      return findAll(this.url, pd)
        .then(res => {
          const dirGroup = _.groupBy(res.data, this.filedMap.name)
          this.dirList = _.toPairs(dirGroup)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
// 固定在顶部的头部区域
.fixed-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: white;
  padding: 12px 20px;
  margin: 0 -10px;
  border-bottom: 1px solid #E5E6EB;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

// 搜索框容器
.search-container {
  margin-bottom: 12px;
  width: 100%;
  :deep(.el-input) {
    .el-input__inner {
      border-radius: 6px;
    }
  }
}

// 已选关键词区域
.selected-container {
  display: flex;
  align-items: flex-start;

  .selected-label {
    font-weight: bold;
    color: #165DFF;
    min-width: 60px;
    margin-top: 4px;
  }

  .selected-items {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    flex: 1;
  }
}

// 关键词列表区域
.dic-wrap {
  padding: 0 10px;
  max-height: calc(60vh - 120px); // 减去固定头部的高度
  overflow-y: auto;
  margin-top: 10px;
}

.dic-item {
  border-top: 1px solid #E5E6EB;
  padding: 16px 0;

  &:first-child {
    border-top: 1px solid transparent;
  }

  .dic-title-con {
    border-right: 1px solid #E5E6EB;

    .dic-title {
      font-family: PingFang SC, PingFang SC, serif;
      font-weight: bold;
      font-size: 14px;
      color: #165DFF;
      line-height: 22px;
      white-space:normal; word-break:break-all;overflow:hidden;
    }
  }

  .keyword-con {
    .keyword {
      position: relative;
      border-radius: 2px;
      // font-family: PingFang SC, PingFang SC, serif;
      font-weight: normal;
      font-size: 14px;
      color: #000;
      line-height: 22px;
      text-align: center;
      margin: 4px;
      padding: 0 5px;
      transition: all 0.3s;

      &:hover {
        background: #f0f7ff;
        color: #165DFF;
      }

      &.selected {
        background: #f0f7ff;
        color: #165DFF;
        font-weight: bold;
      }

      .selected-icon {
        position: absolute;
        top: -5px;
        right: -5px;
        color: #fff;
        background: #165DFF;
        border-radius: 50%;
        font-size: 10px;
        width: 14px;
        height: 14px;
        line-height: 14px;
      }
    }
  }
}

:deep(.el-dialog__body) {
  padding: 15px 20px;
  position: relative;
}

// 调整弹窗内边距
.keyword-dialog :deep(.el-dialog__body) {
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  height: 60vh;
}

// 确保内容区域正确滚动
.keyword-dialog :deep(.el-dialog) {
  display: flex;
  flex-direction: column;

  .el-dialog__body {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
}
</style>
